var render = function render(_c,_vm){return _c('div',[(
      _vm.props.row[_vm.props['column']].activity_values[0] &&
      !isNaN(Number(_vm.props.row[_vm.props['column']].activity_values[0].price))
    )?[_c('format',{attrs:{"value":Number(_vm.props.row[_vm.props['column']].activity_values[0].price) === 0 &&
        _vm.props.row['increment_rates'] &&
        _vm.props.row['increment_rates'][0] &&
        _vm.props.row['increment_rates'][0].rate_value
          ? _vm.props.row['increment_rates'][0].rate_value
          : _vm.props.row[_vm.props['column']].activity_values[0].price}})]:_c('iconwarning')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }